import React from "react";
import adImage from "../../assets/images/community.jpg";
import AdvertisingCountryDropdown from "./AdvertisingCountryDropdown";
import EcomerceCountryDropdown from "./EcomerceCountryDropdown";
import { Link } from "react-router-dom";

const Advertisers = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="bg-pink-100 py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Text Block */}
          <div>
            <h1
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-pink-600 mb-6 leading-tight"
              style={{ fontFamily: "Barlow Semi Condensed" }}
            >
              Promote Your Business to Women in 250 Countries
            </h1>

            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
              Advertise your services on Pink Help — the official platform of
              Women of the World, Inc. Reach thousands of women actively
              searching for trusted providers in health, legal, education,
              business, jobs, and more.
            </p>
            <p className="text-sm sm:text-md text-gray-700 leading-relaxed mb-6">
              Our highly targeted platform offers powerful visibility across
              250+ country-specific portals.
            </p>

            <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center my-8">
              <Link to="/pinkhelp/advertising-portal/">
                <button
                  onClick={() => {
                    document
                      .getElementById("partner-section")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="bg-gradient-to-r from-pink-500 to-pink-700 text-white px-8 py-3 rounded-full font-semibold text-lg shadow-md hover:shadow-xl hover:scale-105 transition-all duration-300"
                >
                  📢 Advertising Portal
                </button>
              </Link>

              <Link to="/pinkhelp/ecommerce-portal/">
                <button
                  onClick={() => {
                    document
                      .getElementById("partner-section")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="bg-gradient-to-r from-blue-500 to-blue-700 text-white px-8 py-3 rounded-full font-semibold text-lg shadow-md hover:shadow-xl hover:scale-105 transition-all duration-300"
                >
                  🛒 Ecommerce Portal
                </button>
              </Link>
            </div>
          </div>

          {/* Image Block */}
          <div className="flex justify-center md:justify-end">
            <img
              src={adImage}
              alt="Advertise on Pink Help"
              className="rounded-3xl shadow-lg mt-14 w-full max-w-md md:max-w-[80%] h-auto"
            />
          </div>
        </div>
      </div>

      {/* Why Advertise Section */}
      <div className="bg-white py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto space-y-16">
          {/* Why List */}
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-pink-600 mb-6">
              Why List With Us?
            </h2>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-base sm:text-lg text-gray-700 list-disc list-inside font-medium">
              <li>Highly targeted women-only audience</li>
              <li>Category-specific exposure across 10 core life areas</li>
              <li>Premium options for homepage & social placement</li>
              <li>Country-level exclusivity available</li>
            </ul>
          </div>

          {/* Ad Packages Table */}
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-pink-600 mb-6">
              Ad Packages
            </h2>
            <div className="overflow-x-auto">
              <table className="min-w-full text-left border border-pink-200 text-sm sm:text-base">
                <thead className="bg-pink-50 text-pink-700">
                  <tr>
                    <th className="py-3 px-4 sm:px-6 border-b">Package</th>
                    <th className="py-3 px-4 sm:px-6 border-b">Features</th>
                    <th className="py-3 px-4 sm:px-6 border-b">Price</th>
                  </tr>
                </thead>
                <tbody className="text-gray-700">
                  <tr className="hover:bg-pink-50">
                    <td className="py-3 px-4 sm:px-6 border-b font-semibold">
                      Standard
                    </td>
                    <td className="py-3 px-4 sm:px-6 border-b">
                      Profile listing, logo, contact info
                    </td>
                    <td className="py-3 px-4 sm:px-6 border-b">$99/mo</td>
                  </tr>
                  <tr className="hover:bg-pink-50">
                    <td className="py-3 px-4 sm:px-6 border-b font-semibold">
                      Premium
                    </td>
                    <td className="py-3 px-4 sm:px-6 border-b">
                      Homepage banner, top placement, social boost
                    </td>
                    <td className="py-3 px-4 sm:px-6 border-b">$299/mo</td>
                  </tr>
                  <tr className="hover:bg-pink-50">
                    <td className="py-3 px-4 sm:px-6 border-b font-semibold">
                      Exclusive
                    </td>
                    <td className="py-3 px-4 sm:px-6 border-b">
                      One advertiser per category/country
                    </td>
                    <td className="py-3 px-4 sm:px-6 border-b">Custom</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Advertisers;
